import { Component, OnInit, HostBinding } from '@angular/core';
import { ElementService, ElementDataImport } from '../service/element.service';

@Component({
	selector: 'common-set-property-import',
	templateUrl: './set-property-import.component.html',
	styleUrls: ['./set-property-import.component.scss']
})
export class SetPropertyImportComponent implements OnInit {
	@HostBinding('class.set-property-import') hostClass = true;
	public svr = this.elementSvr.data.import as ElementDataImport;
	constructor(public elementSvr: ElementService) {}

	ngOnInit() {}
}
